// Browser-specific utility functions
export { convertCookieToKey } from './cookie';
